<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <md-field>
        <label>查找</label>
        <md-input v-model="search" type="text"></md-input>
      </md-field>
    </li>
    <li class="md-small-hide md-xsmall-hide">
      <a href="#" class="dropdown-toggle" data-toggle="dropdown">
        <i class="material-icons">dashboard</i>
        <p>首页</p></a
      >
    </li>
    <li class="md-small-hide md-xsmall-hide">
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
          <i class="material-icons">notifications</i>
          <span class="notification">2</span>
          <p>短消息</p>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li><a href="#">场景模型更新</a></li>
          <li><a href="#">设备元件定义更新</a></li>
        </ul>
      </drop-down>
    </li>
    <li class="md-small-hide md-xsmall-hide">
      <a href="#" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">person</i>
        <p>账户</p></a
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      search: null,
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
    };
  },
};
</script>
